// app/javascript/controllers/scroll_to_section_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  scrollToTarget(event) {
    event.preventDefault()
    
    const targetId = this.element.dataset.sectionId
    const targetElement = document.getElementById(targetId)
    const offset = parseInt(this.element.dataset.offset, 10) || 0
    
    if (targetElement) {
      const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      })
    }
  }
}